module.exports = __webpack_public_path__ + "img/delete.93d252d4.png";